import Point from './Point';

type TurnType = [Point, Point];

const DEG2RAD = Math.PI / 180;
// all credit to https://openhome.cc/eGossip/OpenSCAD/3DTurtleGraphics.html
class Turtle3D {
    //using points as vectors - it's probably ok
    xUnit: Point;
    yUnit: Point;
    zUnit: Point;

    point: Point;

    constructor() {
        this.point = new Point(0, 0, 0);

        this.xUnit = new Point(1, 0, 0);
        this.yUnit = new Point(0, 1, 0);
        this.zUnit = new Point(0, 0, 1);
    }

    getPoint(): Point {
        return this.point;
    }

    clone(): Turtle3D {
        const t3d = new Turtle3D();
        t3d.point = this.point;

        t3d.xUnit = this.xUnit;
        t3d.yUnit = this.yUnit;
        t3d.zUnit = this.zUnit;

        return t3d;
    }

    private _move(by: number, axis: Point): void {
        const offset = axis.multScalar(by);
        this.point = this.point.addPoint(offset);
    }

    moveX(by: number): void {
        this._move(by, this.xUnit);
    }

    moveY(by: number): void {
        this._move(by, this.yUnit);
    }

    moveZ(by: number): void {
        this._move(by, this.zUnit);
    }

    private turn(axis1: Point, axis2: Point, by: number): TurnType {
        const cosA = Math.cos(by * DEG2RAD);
        const sinA = Math.sin(by * DEG2RAD);

        const axis1CosA = axis1.multScalar(cosA);
        const axis2SinA = axis2.multScalar(sinA);

        const axis1NegSinA = axis1.neg().multScalar(sinA);
        const axis2CosA = axis2.multScalar(cosA);

        const axis1New = axis1CosA.addPoint(axis2SinA);
        const axis2New = axis1NegSinA.addPoint(axis2CosA);
        return [axis1New, axis2New];
    }

    turnX(by: number): void {
        [this.yUnit, this.zUnit] = this.turn(this.yUnit, this.zUnit, by);

        // y axis
        //  ptPlus(mlt(getCoordVt(turtle)[1], cos(a)),
        //         mlt(getCoordVt(turtle)[2], sin(a))),
        //z axis
        //  ptPlus(mlt(neg(getCoordVt(turtle)[1]), sin(a)),
        //         mlt(getCoordVt(turtle)[2], cos(a)))
    }

    turnY(by: number): void {
        [this.xUnit, this.zUnit] = this.turn(this.xUnit, this.zUnit, by);
        //x axis
        // ptPlus(mlt(getCoordVt(turtle)[0], cos(a)),
        //        mlt(neg(getCoordVt(turtle)[2]), sin(a))),
        //z axis
        // ptPlus(mlt(getCoordVt(turtle)[0], sin(a)),
        //        mlt(getCoordVt(turtle)[2], cos(a)))
    }

    turnZ(by: number): void {
        [this.xUnit, this.yUnit] = this.turn(this.xUnit, this.yUnit, by);
        //x-axis
        // ptPlus(mlt(getCoordVt(turtle)[0], cos(a)),
        //        mlt(getCoordVt(turtle)[1],sin(a))),

        //y-axis
        // ptPlus(mlt(neg(getCoordVt(turtle)[0]), sin(a)),
        //        mlt(getCoordVt(turtle)[1], cos(a))),
    }
}

export default Turtle3D;
